export enum ReservationStatus {
	Pending = 'Pending',
	Confirmed = 'Confirmed',
	Expired = 'Expired'
}

export type ReservationModel = {
	id: string;
	owner: {
		id: string;
		type: string;
	};
	expiry: string;
	status: ReservationStatus;
	maxExpiryUtcDateTime: string;
	count: number;
	fieldId?: string;
};

export type EventCapacityData = {
	status?: EventCapacityStatus;
	reservation?: ReservationModel;
	customWaitlistMessage?: string;
	capacityRemaining?: number;
	waitlistCapacityRemaining?: number;
	ticketsEnabled?: boolean;
};

export enum EventCapacityStatus {
	Available = 'Available',
	OnWaitlist = 'OnWaitlist',
	Full = 'Full',
	Closed = 'Closed',
	NoLimit = 'NoLimit'
}

export enum ReservationUpdate {
	Add = 'Add',
	Remove = 'Remove'
}

export type RSVPAnswer = {
	id?: string;
	count?: number;
};

export const RSVP_WAITLIST_ANSWER = 'on_waitlist';
